import React from 'react';
import { Link } from "react-router-dom";

import heroimg from '../assets/images/Sign In/Hero-bg.jpg';
import btnsrow from '../assets/images/icons/button-arrow.svg';
import backimg from '../assets/images/Sign In/Back.png'

class Forgotpassword extends React.Component {
   
    render() {
        
        return (
        <section id="forget-pass" class="section fix forget-pass">
            <div className="container-fluid">
                    <Link className="back-img" to="/signin"><img src={backimg} alt="back image" /></Link>
                    <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12" id="signin_mob-padd">
                        <div className="singin-pass-form-details">
                        <h2 className="projetc_ttls"><Link className="main_logohm" to="/">EXCLUSIVE GULETS </Link></h2>
                            <p className="title">Forgot Password</p>
                            <h2 class="main-title">Reset your password here</h2>
                            <p class="subline-text">Enter Details below to get reset link</p>
                            <form>
                                <div class="form-group">
                                <label for="InputEmail1">Email:</label>
                                <input type="email" class="form-control" id="InputEmail1" aria-describedby="emailHelp" placeholder="your@email.com"/>
                                </div>
                                <div class="forget-btn-div">
                                <button type="submit" class="btn btn-theme btn-primary">
                                    Reset Password
                                <img src={btnsrow} className="img-responsive" alt="arrow"/>
                                </button>
                                </div>
                                <p class="creat-acc-link"><Link className="creat_link" to="/signin">Oh Wait I remeber it!</Link></p>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 no-padding" id="mobile_hidesignin">
                        <div className="rightside-image signin-right">
                            <img id="signimgs" src={heroimg} className="img-responsive sign_img" alt="Hero BG"/>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Forgotpassword;